export default interface NotificationInterface {
  id: string;
  title: string;
  description: string;
  authorName: string;
  dtNotification: string;
  dtLastRefresh: string;
  notificationTypeId:string,
  usersId:string[],
  investorIds:string[],
  hasAppUrl:boolean,
  url:string,
  body:string,
  typeTilte: string;
  webAppEmails: WebAppEmail[]
  emailTag: string;
  requestNotificationData: NotificationRequest;
}

interface WebAppEmail{
  id: string;
  userId: string;
  email: string;
  copyEmail: string;
  link: string;
  dtSendEmail:string;
  status:string;
  fullName:string;
  opensCount: string;
  clicksCount: string;
}

const webAppEmailInitialValue: WebAppEmail = {
  id: String(),
  userId: String(),
  email: String(),
  copyEmail: String(),
  link: String(),
  dtSendEmail:String(),
  status:String(),
  fullName:String(),
  opensCount: String(),
  clicksCount: String(),
}

interface NotificationRequest{
  pageRequest: string;
  dataId: string;
  fundName: string;
  productName: string;
}

const notificationInitialValue: NotificationInterface = {
  id: String(),
  title: String(),
  notificationTypeId: String(),
  url:String(),
  usersId:[],
  investorIds: [],
  hasAppUrl: Boolean(true),
  description: String(),
  authorName: String(),
  dtNotification: String(),
  dtLastRefresh: String(),
  typeTilte: String(),
  body: String(),
  webAppEmails: [],
  emailTag: String(),
  requestNotificationData: { dataId: String(), pageRequest: String(), fundName: String(), productName: String()},
};

export { webAppEmailInitialValue, notificationInitialValue, WebAppEmail };
